import { render, staticRenderFns } from "./formConsulta.vue?vue&type=template&id=9de52e3a&"
import script from "./formConsulta.js?vue&type=script&lang=js&"
export * from "./formConsulta.js?vue&type=script&lang=js&"
import style0 from "./formConsulta.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports